export default __webpack_public_path__ + "static/media/icon-card-custom-fields-positioning.5de9e975.svg";